import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Button } from 'components/buttons/button';
import { ButtonType } from 'components/buttons/button-types';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import { LiveChatPages, LiveChatStore } from '../live-chat.store';

const EndChat = observer(({
  styles,
  handleChatEnd,
  localStore
}: {
  styles: { [key: string]: string };
  handleChatEnd: () => void;
  localStore: LiveChatStore;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Card
        classes={['no-margin', 'px-0 pb-0']}
        backgroundType={CardThemeType.Light}
        allowOverflow={true}
        mobilePadding={false}
      >
        <div className={`text-center cust-px-4 ${styles.endChatContainer}`}>
          <h4 className="cust-mb-3 cust-pt-1 text-large">{t('liveChat.endChat.title')}</h4>

          <div className="text-regular cust-px-4 text-center cust-mb-4">{t('liveChat.endChat.description')}</div>

          <div className="d-flex justify-content-center cust-mt-4">
            <Button
              meta={{
                name: t('common.no'),
                title: t('common.no'),
                type: ButtonType.OutlineDark,
              }}
              classes={['cust-ml-1', styles.buttonStyle]}
              onClick={() => localStore.changeActivePage(LiveChatPages.LiveChat)}
            />
            <Button
              meta={{
                name: t('common.yes'),
                title: t('common.yes'),
                type: ButtonType.Dark,
              }}
              classes={['cust-ml-1', styles.buttonStyle]}
              onClick={handleChatEnd}
            />
          </div>
        </div>
      </Card>
    </>
  );
});
export default EndChat;